module.exports = __webpack_public_path__ + "static/media/parrot.b3f3cb89.gif";